var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 37 37",
    fill: "#5D5858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_1596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8459 21.1492C26.1331 20.3817 26.2788 19.5686 26.2759 18.7492C26.2759 16.9298 25.5532 15.1849 24.2667 13.8984C22.9802 12.6119 21.2353 11.8892 19.4159 11.8892C18.6066 11.8901 17.804 12.0357 17.0459 12.3192L18.6559 13.9792C18.9006 13.94 19.148 13.9199 19.3959 13.9192C20.6823 13.9165 21.9176 14.4229 22.8319 15.3279C23.7462 16.2328 24.2653 17.4628 24.2759 18.7492C24.2751 18.997 24.255 19.2444 24.2159 19.4892L25.8459 21.1492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9467 18.2792C31.5767 12.0492 25.6667 8.27917 19.1267 8.27917C17.3461 8.28336 15.5774 8.57026 13.8867 9.12917L15.4967 10.7492C16.6826 10.4427 17.9019 10.2848 19.1267 10.2792C24.7567 10.2792 29.8767 13.4192 32.9267 18.7092C31.8079 20.6718 30.3247 22.4028 28.5567 23.8092L29.9767 25.2292C32.0228 23.5785 33.7221 21.5394 34.9767 19.2292L35.2367 18.7492L34.9467 18.2792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52613 6.52918L9.98613 10.9892C7.16705 12.8043 4.86303 15.315 3.29613 18.2792L3.03613 18.7492L3.29613 19.2292C6.66613 25.4592 12.5761 29.2292 19.1161 29.2292C21.6688 29.2287 24.1883 28.6509 26.4861 27.5392L31.4861 32.5392L33.2361 31.0392L7.23613 5.03918L5.52613 6.52918ZM15.2761 16.2792L21.9261 22.9292C21.1748 23.3943 20.3098 23.6434 19.4261 23.6492C18.7841 23.6492 18.1483 23.5222 17.5555 23.2756C16.9627 23.029 16.4245 22.6676 15.9719 22.2122C15.5193 21.7568 15.1612 21.2164 14.9182 20.6221C14.6752 20.0277 14.5522 19.3912 14.5561 18.7492C14.5674 17.8757 14.8163 17.0219 15.2761 16.2792ZM13.8261 14.8292C12.8906 16.1486 12.4521 17.7565 12.5882 19.3682C12.7244 20.9799 13.4265 22.4914 14.5702 23.6351C15.7139 24.7788 17.2255 25.4809 18.8371 25.6171C20.4488 25.7533 22.0567 25.3148 23.3761 24.3792L24.9761 25.9792C23.1239 26.7709 21.1305 27.1791 19.1161 27.1792C13.4861 27.1792 8.36613 24.0392 5.31613 18.7492C6.77984 16.1574 8.88786 13.9874 11.4361 12.4492L13.8261 14.8292Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.65625 0.749146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/Eye-hide.6168538fbdddf9e43b5cd1cd7ef05a32.svg";
export { ForwardRef as ReactComponent };